import React from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { createActions } from '../../../../store';
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';
import CondensedListItem from '../../../../../../list-items/CondensedListItem';
import VisualizerFireIntensityListItem from './VisualizerFireIntensityListItem';
import VisualizerFireDetailListItem from './VisualizerFireDetailListItem';

const VisualizerFireListItem = (props) => {
    const { fireSettingsEnabled, updateVisualizerSettings } = props;

    const onFireEnabledChange = (value) => updateVisualizerSettings({ 
        fireSettings: { enabled: value }
    });
    
    return (
        <CollapsibleSwitchListItem
            checked={fireSettingsEnabled}
            text='Fire'
            onChange={onFireEnabledChange}
        >
            <List dense disablePadding>
                <CondensedListItem
                    elements={[
                        {
                            width: 6,
                            component: <VisualizerFireIntensityListItem />
                        },
                        {
                            width: 6,
                            component: <VisualizerFireDetailListItem />
                        }
                    ]}
                />
            </List>
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state) => {
    const { enabled: fireSettingsEnabled } = state.createPreview.present.videoSettings.visualizer.fireSettings;
    return { fireSettingsEnabled };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerFireListItem);